module.exports = __webpack_public_path__ + "img/yzb.08bb4d25.png";